import { render, staticRenderFns } from "./ZDMLanternPatternsTab.vue?vue&type=template&id=7bc4a831&scoped=true&"
import script from "./ZDMLanternPatternsTab.vue?vue&type=script&lang=js&"
export * from "./ZDMLanternPatternsTab.vue?vue&type=script&lang=js&"
import style0 from "./ZDMLanternPatternsTab.vue?vue&type=style&index=0&id=7bc4a831&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc4a831",
  null
  
)

export default component.exports